import React from "react";
import { useFiltersForQuery } from "src/contexts/filterAndFte/FilterAndFteContext";
import { isPeoplePage, isSummaryPage } from "src/util/url";
import { matchPaths } from "src/consts/urlPaths";
import useRestricted from "src/app/Restricted/useRestricted";
import NovaSideNav from "src/components/SideNav/NovaSideNav";
import { withSidebarContextProvider } from "./context";
import useSidebarDataQuery from "./useSidebarDataQuery";
import useLocationSidebarEffects from "./useLocationSidebarEffects";

const SidebarContainer = () => {
  const [isDirectoryUser] = useRestricted();
  const match = matchPaths();
  const shouldGetFilters =
    (isSummaryPage(match?.path) || isPeoplePage(match?.path)) &&
    !isDirectoryUser;

  const filters = useFiltersForQuery();
  useSidebarDataQuery(filters, shouldGetFilters);
  useLocationSidebarEffects();

  return <NovaSideNav />;
};

export default withSidebarContextProvider(SidebarContainer);
